import { Dispatch } from "redux";
import { getTokenDataService, getAuthorizationValue, getGoogleAuthDataService, verifyAuth, getPasswordChange, verifyPasswordChange, getSIMADataService, checkSIMAStatusService } from '../../../services/login'
import { LoginAction, LoginActionTypes } from "../../types/login";
import { TokenAction, TokenActionTypes } from "../../types/token";
import { GoogleAuthAction, GoogleAuthActionTypes } from "../../types/googleAuth";

import { Notify } from 'components/Notification'
import { useHistory } from "react-router-dom";
import { getLoggedUserInfo } from "../../../services/Auth/GetUserInfo";
import { secureLocalStorageSet, secureLocalStorageGet } from "../../../helpers";
import { SalaryActionTypes } from "store/types/salary";

export const getGoogleAuth = (args: Object, history: any) => {
  return (dispatch: Dispatch<GoogleAuthAction>) => {
    return new Promise(() => {
      dispatch({ type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_REQUEST })

      getGoogleAuthDataService(args)
        .then(response => {
          dispatch({
            payload: {
              result: response,
            },
            type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_SUCCESS,
          })

          let typeAuth_token = response.headers.auth_token.substr(response.headers.auth_token.length - 3);

          if (typeAuth_token === "ANM" && !("role" in response.data)) {
            localStorage.setItem('auth_token', response.headers.auth_token)
            secureLocalStorageSet('username', args.userName)
            secureLocalStorageSet('channel', args.authType)
            // args.authType == 'OTP' ? localStorage.setItem('channel', 'OTP') : localStorage.setItem('username', args.userName)
            args.authType == 'OTP' ? dispatch(changeRoute(2)) : dispatch(changeRoute(1))
          } else if (typeAuth_token === "OTP" && "role" in response.data) {
            secureLocalStorageSet('username', args.userName)
            secureLocalStorageSet('channel', args.authType)
            let userData = {
              customerData: response.data.customers.asanCustomerList,
              userName: response.data.userName,
              usersSurName: response.data.usersSurName,
              permissions: response.data.permissions,
              totalApproverCount: response.data.totalApproverCount,
              totalSignerCount: response.data.totalSignerCount,
              isTOTPEnabled: response.data.isTOTPEnabled
            }
            if (response.data.customers) {
              var fav = response.data.customers.asanCustomerList.filter(e => e.favorite === 'Y')
              var result = fav[0]
              // localStorage.setItem("currentCompany", JSON.stringify(result))
              secureLocalStorageSet("currentCompany", result)
            }
            localStorage.setItem('auth_token_verifyed', response.headers.auth_token)
            // localStorage.setItem("userData", JSON.stringify(userData))
            secureLocalStorageSet("userData", userData)
            // localStorage.setItem("permissions", JSON.stringify(response.data.permissions))
            secureLocalStorageSet("permissions", response.data.permissions)
            secureLocalStorageSet("rol", response.data.role)
            // localStorage.setItem("rol", response.data.role)

            getLoggedUserInfo().then(resp => {
              secureLocalStorageSet('phoneNumber', resp.phoneNumber)
              // localStorage.setItem('phoneNumber', resp.phoneNumber)
            });

            if (response.data.forcePassword == 'Y') {
              dispatch(changeRoute(3))
            } else {
              history.push('/')
            }
          }


        })
        .catch((error: any) => {
          dispatch({
            error: {
              result: error.response,
            },
            type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_ERROR,
          })
          history.push('/login')
          dispatch(changeRoute(0))
          // Notify(error.response.data.messages[0].MESSAGE)
        })
    })
  }
}

export const getSmsAgain = (psw: any) => {
  let postData = {
    authType: "OTP",
    channel: "INT",
    // password: localStorage.getItem('passwordValue'),
    password: psw,
    userName: secureLocalStorageGet('username')
  }
  return (dispatch: Dispatch<GoogleAuthAction>) => {
    return new Promise(() => {
      dispatch({ type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_REQUEST })

      getGoogleAuthDataService(postData)
        .then(response => {
          dispatch({
            payload: {
              result: response,
            },
            type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_SUCCESS,
          })
          localStorage.setItem('auth_token', response.headers.auth_token)
          secureLocalStorageSet('username', postData.userName ? postData.userName : '')
          secureLocalStorageSet('channel', postData.authType)
        })
        .catch((error: any) => {
          dispatch({
            error: {
              result: error.response,
            },
            type: GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_ERROR,
          })
          // Notify(error.response.data.messages[0].MESSAGE)
        })
    })
  }
}

export const verifyAuthData = (args: Object, history: any) => {

  let postData = {
    userName: secureLocalStorageGet('username'),
    channel: 'INT',
    verfication: args
  }
  return (dispatch: Dispatch<GoogleAuthAction>) => {
    return new Promise(() => {
      dispatch({ type: GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_REQUEST })
      verifyAuth(postData)
        .then(response => {
          dispatch({
            payload: {
              result: response.messages,
            },
            type: GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_SUCCESS,
          })
          let userData = {
            customerData: response.data.customers.asanCustomerList,
            userName: response.data.userName,
            usersSurName: response.data.usersSurName,
            permissions: response.data.permissions,
            totalApproverCount: response.data.totalApproverCount,
            totalSignerCount: response.data.totalSignerCount,
            isTOTPEnabled: response.data.isTOTPEnabled
          }
          if (response.data.customers) {
            var fav = response.data.customers.asanCustomerList.filter(e => e.favorite === 'Y')
            var result = fav[0]
            // localStorage.setItem("currentCompany", JSON.stringify(result))
            secureLocalStorageSet("currentCompany", result)
          }
          localStorage.setItem('auth_token_verifyed', response.headers.auth_token)
          // localStorage.setItem("userData", JSON.stringify(userData))
          secureLocalStorageSet("userData", userData)
          // localStorage.setItem("permissions", JSON.stringify(response.data.permissions))
          secureLocalStorageSet("permissions", response.data.permissions)
          // localStorage.setItem("rol", response.data.role)
          secureLocalStorageSet("rol", response.data.role)

          getLoggedUserInfo().then(resp => {
            secureLocalStorageSet('phoneNumber', resp.phoneNumber)
            // localStorage.setItem('phoneNumber', resp.phoneNumber)
          });

          if (response.data.forcePassword == 'Y') {
            dispatch(changeRoute(3))
          } else {
            history.push('/')
          }
        })
        .catch((error: any) => {
          // if(error.response.data) {
          //   Notify(error.response.data.messages[0].MESSAGE)
          // }
          Notify(error.response.data.messages[0].MESSAGE)
          dispatch({
            error: error,
            type: GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_ERROR,
          })
        })
    })
  }
}

export const getTokenData = (args: Object, history: any) => {
  return (dispatch: Dispatch<TokenAction>) => {
    return new Promise(() => {
      dispatch({ type: TokenActionTypes.GET_TOKEN_DATA_REQUEST })
      getTokenDataService(args)
        .then(response => {
          dispatch({
            payload: {
              result: response,
            },
            type: TokenActionTypes.GET_TOKEN_DATA_SUCCESS,
          })
          localStorage.setItem('auth_token', response.headers.auth_token)
          dispatch(getAuthorizationData(history))
        })
        .catch((error: any) => {
          history.push('/login')
          dispatch({
            error: {
              result: error.response,
            },
            type: TokenActionTypes.GET_TOKEN_DATA_ERROR,
          })
          if (error.response && error.response.data) {
            Notify(error.response.data.messages[0].MESSAGE)
          }
        })
    })
  }
}

export const getAuthorizationData = (history: any) => {
  return (dispatch: Dispatch<TokenAction>) => {
    return new Promise(() => {
      dispatch({ type: TokenActionTypes.GET_AUTHORIZATION_VALUE_REQUEST })
      dispatch(changeRoute(4))
      getAuthorizationValue(history)
        .then((response: any) => {
          dispatch({
            payload: {
              result: response,
            },
            type: TokenActionTypes.GET_AUTHORIZATION_VALUE_SUCCESS,
          })

          // if (response.data.mSignStatus == 'CANCELLED' || response.data.mSignStatus == 'SIM_ERROR' || response.data.result == 305) {
          //   dispatch(changeRoute(0))
          //   dispatch(changeTab(3))
          //   localStorage.clear()
          // } else if (response.data.result == 350) {
          //   dispatch(changeRoute(0))
          //   dispatch(changeTab(3))
          //   localStorage.clear()
          //   const res = {
          //     "data": {
          //       "messages": [
          //         {
          //           "MESSAGE": response.data.errMessage
          //         }
          //       ]
          //     }
          //   }
          //   dispatch({
          //     error: res,
          //     type: TokenActionTypes.GET_AUTHORIZATION_VALUE_ERROR,
          //   })
          // }

          secureLocalStorageSet('channel', 'ASAN')
          if (response.data.errMessage !== "" && response.data.errMessage !== null) {
            dispatch(changeRoute(0))
            dispatch(changeTab(3))
            localStorage.clear()
            const res = {
              "data": {
                "messages": [
                  {
                    "MESSAGE": response.data.errMessage
                  }
                ]
              }
            }
            dispatch({
              error: res,
              type: TokenActionTypes.GET_AUTHORIZATION_VALUE_ERROR,
            })
          }
        })
        .catch((error: any) => {
          dispatch({
            error: {
              result: error.response,
            },
            type: TokenActionTypes.GET_AUTHORIZATION_VALUE_ERROR,
          })
        })
    })
  }
}

export const getPasswordChangeData = (args: Object, authType: Object, history: any) => {
  return (dispatch: Dispatch<GoogleAuthAction>) => {
    return new Promise(() => {
      dispatch({ type: GoogleAuthActionTypes.GET_PASSWORD_CHANGE_REQUEST })

      getPasswordChange(args)
        .then(response => {
          dispatch({
            payload: {
              result: response,
            },
            type: GoogleAuthActionTypes.GET_PASSWORD_CHANGE_SUCCESS,
          })
          if (response.data.errCode === 1) {
            localStorage.setItem('verify', 'verification')
            // history.push('/')
            authType.authType == 'OTP' ? dispatch(changeRoute(2)) : dispatch(changeRoute(1))
            // dispatch(changeRoute(2))
          }
        })
        .catch((error: any) => {
          dispatch({
            error: error,
            type: GoogleAuthActionTypes.GET_PASSWORD_CHANGE_ERROR,
          })
          if (error.response && error.response.data) {
            Notify(error.response.data.messages[0].MESSAGE)
          }
        })
    })
  }
}

export const verifyPasswordChangeData = (args: Object, history: any) => {
  return (dispatch: Dispatch<GoogleAuthAction>) => {
    return new Promise(() => {
      dispatch({ type: GoogleAuthActionTypes.VERIFY_CHANGE_PASSWORD_REQUEST })

      verifyPasswordChange(args)
        .then(response => {
          dispatch({
            payload: {
              result: response,
            },
            type: GoogleAuthActionTypes.VERIFY_PASSWORD_CHANGE_SUCCESS
          })
          localStorage.removeItem('verify')
          history.push('/')
        })
        .catch((error: any) => {
          dispatch({
            error: error,
            type: GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_ERROR,
          })
          // Notify(error.response.data.messages[0].MESSAGE)
        })
    })
  }
}

export const signout = (history: any) => {
  return (dispatch: Dispatch<LoginAction>) => {
    localStorage.removeItem('auth_token')
    history.push('/login')
    dispatch(changeRoute(0))
    dispatch({
      type: LoginActionTypes.SIGN_OUT
    })
  }
}

export const cancelAsanSign = () => {
  return (dispatch: Dispatch<TokenAction>) => {
    // dispatch(changeRoute(0))
    dispatch({
      type: TokenActionTypes.GET_AUTHORIZATION_VALUE_SUCCESS,
      payload: {
        result: {
          data: {
            mSignStatus: 'CANCELLED'
          }
        }
      }
    })
  }
}

export const getSIMALogin = (history: any) => {
  // A fresh QR request supersedes any running poll loop and clears the guard so
  // the new poll (started once the QR arrives) is never blocked by a stale one.
  simaPollGeneration++
  simaCheckInFlight = false
  if (simaPollTimer) {
    clearTimeout(simaPollTimer)
    simaPollTimer = null
  }
  return (dispatch: Dispatch<TokenAction>) => {
    return new Promise(() => {
      dispatch({ type: TokenActionTypes.GET_SIMA_DATA_REQUEST })
      getSIMADataService()
        .then(response => {
          dispatch({
            payload: response.data,
            type: TokenActionTypes.GET_SIMA_DATA_SUCCESS,
          })
          localStorage.setItem('auth_token', response.headers.auth_token)
        })
        .catch((error: any) => {
          const rawError = error
          console.log(rawError)
          const normalizedError = typeof rawError === 'string'
            ? { messages: [{ MESSAGE: rawError }] }
            : rawError
          dispatch({
            error: normalizedError || error,
            type: TokenActionTypes.GET_SIMA_DATA_ERROR,
          })
        })
    })
  }
}

let simaCheckInFlight = false
let simaPollGeneration = 0
let simaPollTimer: any = null

// Stops the recursive poll loop: bumps the generation so any in-flight or
// scheduled poll bails, clears the guard, and cancels a pending setTimeout.
// Called on tab switch / unmount so polling can't keep running (or push
// navigation) after the user has left the SIMA tab.
export const stopSIMAPolling = () => {
  simaPollGeneration++
  simaCheckInFlight = false
  if (simaPollTimer) {
    clearTimeout(simaPollTimer)
    simaPollTimer = null
  }
  return { type: '@@sima/STOP_POLLING' } as any
}

export const pollSIMAStatus = (history: any) => {
  return (dispatch: Dispatch<TokenAction>) => {
    if (simaCheckInFlight) return
    const generation = simaPollGeneration
    simaCheckInFlight = true
    dispatch({ type: TokenActionTypes.GET_SIMA_STATUS_REQUEST })
    checkSIMAStatusService()
      .then((response: any) => {
        simaCheckInFlight = false
        // This loop was superseded (fresh QR) or stopped (tab switch) — abandon it.
        if (generation !== simaPollGeneration) return
        if (typeof response.data === 'string') {
          dispatch({
            error: { messages: [{ MESSAGE: response.data }] },
            type: TokenActionTypes.GET_SIMA_STATUS_ERROR,
          })
          return
        }

        const isAuthorized =
          (response.data.mSignStatus === 'AUTHORIZED' && response.data.result == 1) ||
          (response.headers?.auth_token && !response.headers.auth_token.endsWith('ANM'))

        const isPending = response.data.mSignStatus === 'OUTSTANDING'

        const isError = !isPending && (
          (typeof response.data.code === 'string' && response.data.code.startsWith('ERROR.')) ||
          (response.data.errCode != null && response.data.errCode !== 0) ||
          (response.data.errMessage != null && response.data.errMessage !== '')
        )

        if (isAuthorized) {
          const userSimaData = {
            customerData: response.data.customers?.asanCustomerList,
            permissions: response.data.permissions,
            userName: response.data.userName,
            usersSurName: response.data.usersSurName,
          }
          const list = response.data.customers?.asanCustomerList
          const fav = list
            ? (list.length !== 1 ? list.find((e: any) => e.favorite === 'Y') : list[0])
            : {
                customerNo: String(response.data.customerNo),
                name: response.data.customerName || `${response.data.usersName ?? ''} ${response.data.usersSurName ?? ''}`.trim(),
                certIdentifier: '',
                organizationCode: '',
                personalCode: '',
              }
          secureLocalStorageSet('currentCompany', fav)
          localStorage.setItem('auth_token_verifyed', response.headers.auth_token)
          secureLocalStorageSet('userData', userSimaData)
          secureLocalStorageSet('username', response.data.userName)
          secureLocalStorageSet('channel', 'SIMA')
          secureLocalStorageSet('rol', response.data.role)
          secureLocalStorageSet('permissions', response.data.permissions)
          dispatch({ type: TokenActionTypes.GET_SIMA_STATUS_SUCCESS, payload: response })
          history.push('/')
        } else if (isError) {
          dispatch({ type: TokenActionTypes.SIMA_EXPIRED })
        } else if (isPending) {
          simaPollTimer = setTimeout(() => {
            if (generation !== simaPollGeneration) return
            (dispatch as any)(pollSIMAStatus(history))
          }, 1000)
        }
      })
      .catch((error: any) => {
        simaCheckInFlight = false
        if (generation !== simaPollGeneration) return
        const rawError = error?.response?.data
        console.log(rawError)
        const normalizedError = typeof rawError === 'string'
          ? { messages: [{ MESSAGE: rawError }] }
          : rawError
        if (normalizedError?.messages) {
          dispatch({
            error: normalizedError,
            type: TokenActionTypes.GET_SIMA_STATUS_ERROR,
          })
        } else {
          dispatch({ type: TokenActionTypes.SIMA_EXPIRED })
        }
      })
  }
}

export const setSimaExpired = () => {
  // The countdown reaching 0 must also tear down the recursive poll loop —
  // otherwise the already-scheduled setTimeout keeps firing status requests
  // after expiry (its generation guard still matches). Mirror stopSIMAPolling.
  simaPollGeneration++
  simaCheckInFlight = false
  if (simaPollTimer) {
    clearTimeout(simaPollTimer)
    simaPollTimer = null
  }
  return (dispatch: Dispatch<TokenAction>) => {
    dispatch({ type: TokenActionTypes.SIMA_EXPIRED })
  }
}

// Reset the SIMA slice to a clean state and stop any lingering poll loop.
// Dispatched when a SIMA screen mounts so returning to the SIMA tab after it
// expired starts fresh (initial "activate" state) instead of the stale
// expired/error screen.
export const resetSIMA = () => {
  simaPollGeneration++
  simaCheckInFlight = false
  if (simaPollTimer) {
    clearTimeout(simaPollTimer)
    simaPollTimer = null
  }
  return (dispatch: Dispatch<TokenAction>) => {
    dispatch({ type: TokenActionTypes.SIMA_RESET })
  }
}

export const changeRoute = (value: number) => {
  return (dispatch: Dispatch<LoginAction>) => {
    dispatch({
      type: LoginActionTypes.CHANGE_ROUTE,
      payload: value
    })
  }
}

export const changeTab = (tabValue: number) => {
  return (dispatch: Dispatch<LoginAction>) => {
    dispatch({
      type: LoginActionTypes.CHANGE_TAB,
      payload: tabValue
    })
  }
}

export const changeLang = (lang: string) => {
  return (dispatch: Dispatch<LoginAction>) => {
    dispatch({
      type: LoginActionTypes.CHANGE_LANG,
      payload: lang
    })
  }
}

export const removeNotification = () => {
  return (dispatch: Dispatch<GoogleAuthAction>) => {
    dispatch({
      type: GoogleAuthActionTypes.REMOVE_NOTIFICATION
    })
  }
}

export const removeNotificationAsan = () => {
  return (dispatch: Dispatch<TokenAction>) => {
    dispatch({
      type: TokenActionTypes.REMOVE_NOTIFICATION_ASAN
    })
  }
}